import { Handle, NodeProps, Position } from 'reactflow';
import { PercentageScaleInput } from '@evoach/ui-components';
import { useIntl } from 'react-intl';

import { translateKey, useGlobalStyles } from './base.node';

/*
  PercentageScaleInput react-flow node for module builder graph canvas
*/

export const PercentageScaleInputNode: React.FC<NodeProps<any>> = (
  nodeProps: any
) => {
  const classes = useGlobalStyles();
  const intl = useIntl();

  const payload = nodeProps.data.state.entry[0].payload;

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={nodeProps.isConnectable}
        className={classes['react-flow__handle']}
      />
      <div
        className={nodeProps.selected ? classes.selectStyletrue : classes.root}
        style={{ width: '340px' }}
      >
        <PercentageScaleInput
          buttonText={translateKey(intl, payload.buttonText)}
          saveResultTo={payload.saveResultTo}
          scale={payload.scale ? parseInt(payload.scale) : 50}
          scaleName={translateKey(intl, payload.scaleName)}
        />
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="scaleoutputhandle"
        isConnectable={nodeProps.isConnectable}
        className={classes['react-flow__handle']}
      />
    </>
  );
};
